import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { ConvertToHtmlPipe } from 'src/app/pipes/toHtml.pipe';
import { KbImportorderComponent } from './kb-importorder.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { onlineOderingGuard } from 'src/app/services/Guards/onlineOrdering/online-odering.guard';

@NgModule({
  declarations: [KbImportorderComponent, ConvertToHtmlPipe],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    KbPipesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KbImportCSVSavedCartFlexComponent: {
          component: KbImportorderComponent,
          guards: [SecureGuard, AuthGuard,onlineOderingGuard]
        },
      },
    } as CmsConfig),
  ],
})
export class KbImportOrderModule { }
